<template>
  <b-modal
    id="new-news-popup"
    title="Create New"
    header-class="border-bottom"
    footer-class="border-top pt-3 justify-content-between"
    centered
    @hidden="selectedType = null">
    Select <img src="@/assets/images/tooltip.svg" alt="Help">
    <b-form-input v-model="selectedType" hidden></b-form-input>
    <div id="options" class="d-flex align-items-center mt-3">
      <div
        v-for="(option, index) in options"
        :key="`option_${index}`"
        :class="['option py-3 px-4 d-flex flex-column align-items-center',
          { 'mr-3': index < options.length + 1, 'selected': 'options' in option ? option.options.map(sub => sub.type).includes(selectedType) : selectedType === option.type }
        ]"
        @click="option.type === 'news' ? selectedType = option.type : null">
        <img src="@/assets/images/new-document.svg" alt="New" class="flex-grow-0 mb-1">
        <b-dropdown
          id="dropdown-1"
          :text="'options' in option && option.options.map(sub => sub.type).includes(selectedType) ? option.options.find(sub => sub.type === selectedType).label : option.label"
          :toggle-class="['p-0 bg-transparent border-0 shadow-none popup-types', !option.options.map(sub => sub.type).includes(selectedType) ? 'text-muted' : 'text-dark']"
          v-if="'options' in option">
          <b-dropdown-item
            v-for="(subOption, subIndex) in option.options"
            :key="`sub_option_${subIndex}`"
            @click.self="selectedType = subOption.type">
            {{ subOption.text }}
          </b-dropdown-item>
        </b-dropdown>
        <span v-else>
          {{ option.label }}
        </span>
      </div>
    </div>
    <template slot="modal-footer">
      <b-button
        pill
        variant="ghost"
        class="mr-1 btn-cancel"
        @click="$root.$emit('bv::hide::modal', 'new-news-popup')">
        Cancel
      </b-button>
      <b-button
        variant="primary" class="ml-1"
        @click="proceedCreate">
        Create
      </b-button>
    </template>
  </b-modal>
</template>

<script>
export default {
  name: "NewNewsAndPopUp",
  data() {
    return {
      selectedType: null,
      options: [
        { label: "News", type: "news" },
        {
          label: "Pop up type",
          type: "popup",
          options: [
            { text: "Poster (325 x 510px)", label: "Poster", type: "poster" },
            { text: "Banner (325 x 215px)", label: "Banner", type: "banner" }
          ]
        }
      ]
    }
  },
  methods: {
    proceedCreate() {
      switch (this.selectedType) {
        case "news":
          this.$router.push({ path: "/engagement/news/design/" });
          break;
        default:
          this.$router.push({ path: `/engagement/popup/design/${this.selectedType}` });
          break;
      }
    }
  }
}
</script>

<style lang="scss" scoped>
#options {
  .option {
    border: 1.5px solid #E1E3E8;
    border-radius: 20px;
    cursor: pointer;
    &.selected {
      border-color: #5182FF;
    }
  }
}
</style>

<style lang="scss">
.popup-types::after {
  background: url("../../../assets/images/caret-down.svg") no-repeat;
  border: 0;
  width: 12px;
  height: 7px;
  position: relative;
  top: 5px;
}
</style>
